import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useNavigate } from 'react-router-dom';
import { CalloutNotification, useLocalizeMessage } from 'libs.nucleus';
import { PageHeader, PageWrapper, useBooleanState } from 'libs.react';
import { DcrFormModal } from '../../components/dcr_form_modal';
import { DcrTable } from '../../components/dcr_table';
import { DCR_MINIMUM_CONNECTOR_VERSION } from '../../constants';
import { useDataChangeRequestsContext, useDcrApiContext } from '../../contexts';
import { useDcrConnectorVersion } from '../../hooks';
import { meetsMinimumConnectorVersion } from '../../utils';
export const DcrListView = ({ subtitle, breadcrumbPages, tableHeaderContent } = {}) => {
    const translate = useLocalizeMessage();
    const navigate = useNavigate();
    const { basePath, canCreate } = useDataChangeRequestsContext();
    const connectorVersion = useDcrConnectorVersion(useDcrApiContext());
    const [isCreateOpen, openCreate, closeCreate] = useBooleanState();
    const headerOptions = canCreate
        ? [{ name: translate('Create data change'), onClick: openCreate, variant: 'primary' }]
        : [];
    // Only a successful read gates the page: a failed fetch says nothing about the connector, and
    // the table's own error state covers a backend that is genuinely unreachable
    const showConnectorUpdateBanner = connectorVersion.isSuccess && !meetsMinimumConnectorVersion(connectorVersion.data);
    return (_jsxs(PageWrapper, { children: [_jsx(PageHeader, { title: translate('Data changes'), subtitle: subtitle, breadcrumbPages: breadcrumbPages, options: headerOptions, LinkComponent: Link }), showConnectorUpdateBanner ? (_jsx(CalloutNotification, { type: 'warning', title: translate('Data change package update required'), subtitle: translate('The data change package must be updated to version {minimum} or later to use the data change experience.', { minimum: DCR_MINIMUM_CONNECTOR_VERSION }) })) : null, isCreateOpen ? (_jsx(DcrFormModal, { onClose: closeCreate, onSubmitted: (dcrId) => {
                    if (dcrId) {
                        navigate(`${basePath}/${dcrId}`);
                    }
                } })) : null, _jsx(DcrTable, { headerContent: tableHeaderContent })] }));
};
